var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotFound',{attrs:{"goBack":_vm.goBack,"height":_vm.height}})
}
var staticRenderFns = []

export { render, staticRenderFns }